import { render, staticRenderFns } from "./NgBreadcrumb.vue?vue&type=template&id=60203531&scoped=true&"
import script from "./NgBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./NgBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./NgBreadcrumb.vue?vue&type=style&index=0&id=60203531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60203531",
  null
  
)

export default component.exports